export default __webpack_public_path__ + "static/media/footerLogo.c28cf946.png";